<form #f="ngForm" (ngSubmit)="onSubmit(f)">
    <div class="row">
        <div class="col-md-6">
            <div class="form_sections">
                <div class="form-group">
                    <label>Please select if the policy is paid</label> 
                    <mat-checkbox name="is_paid" value="1" [(ngModel)]="quote.is_paid"
                        [checked]="quote.is_paid == 1">
                        Is Paid?
                    </mat-checkbox>
                </div>
            </div>

            <div class="form_sections">
                <div class="form-group">
                    <label>Paid Date</label><br>
                    <input type="text" required name="paid_date" [(ngModel)]="quote.paid_date"
                        #paid_date="ngModel" placeholder="Paid Date" class="form-control form-control-sm datepicker"
                        [ngClass]="{ 'is-invalid': f.submitted && paid_date.invalid }" matInput
                        (focus)="myDatepicker.open()" [matDatepicker]="myDatepicker">
                    <mat-datepicker-toggle [for]="myDatepicker"></mat-datepicker-toggle>
                    <mat-datepicker #myDatepicker></mat-datepicker>
                    <div *ngIf="f.submitted && paid_date.invalid" class="invalid-feedback">
                        Paid date is required.
                    </div>
                </div>
            </div>
            
            <div class="form-group">
                <button type="submit" name="submit" class="btn btn-success btn-sm">Submit</button>
            </div>
        </div>
    </div>
</form>